<template>
  <div class="popupWrapper" :class="{ hidden: !showCurrencyPopup }">
    <div
        ref="popup"
      class="popup popup--bubble bg-white shwadow"
      :aria-hidden="showCurrencyPopup ? 'false' : 'true'"
      data-popup="popup"
      v-click-outside="hidePopup"
    >
      <a
        :href="'#' + key"
        v-for="(currency, key) in currencies"
        :key="key"
        class="cursel"
        :data-currency="key"
        data-bindclick
        @click.prevent="changeCurrency(key)"
        @keyup.enter.prevent="changeCurrency(key)"
      >
        {{ currency.symbol }} - {{ key }}
      </a>
    </div>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "CurrencyPopup",
  components: {},
  props: {
    currencies: Object,
    currencyModule: Object,
    showCurrencyPopup: Boolean,
  },
  data: function () {
    return {
      isJustOpened: true,
    };
  },

  computed: {
    currency() {
      return this.$store.state.propertyCurrency;
    },
  },
  methods: {
    changeCurrency: function (currency) {
      this.$store.commit("setCurrency", currency);
      this.$emit("changeCurrency");
      for (let i = 0; i < this.currencies.length; i++) {
				this.currencies[i].active = false
			}
			this.currencies[currency].active = true
			if(this.currencyModule.updatePriceTagsExternal)	this.currencyModule.updatePriceTagsExternal(currency, this.currencies[currency].symbol
        );
      this.isJustOpened = true;
    },
    hidePopup: function () {
      if (this.isJustOpened) {
        this.isJustOpened = false;
      } else {
        this.$emit("hide");
        this.$refs.popup.style = 'display: none;'
        this.isJustOpened = true;
      }
    },
  },
  watch: {
    currencyModule: function () {
      //this.changeCurrency(this.currency)
    },
    showCurrencyPopup: function(){
      // focus first currency
      setTimeout(() => {
        if (this.showCurrencyPopup) {
          this.$refs.popup.removeAttribute('style')
          this.$refs.popup.querySelector('a').focus()
        }
        else {
          this.$refs.popup.style = 'display: none;'
        }
      }, 217)
    }
	},

  directives: {
    ClickOutside,
  },
};
</script>